module.exports = __webpack_public_path__ + "img/2025-07-21a_9.52da3869.jpg";